import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getAllProducts, saveSouscription } from '../../lib/apis';
import Loader from '../../components/loader';
import CustomButton from '../../components/customButton';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { scrollToTop } from '../../lib/utils';

function SelectProducts() {
  const duration = useLocation().state
  const [inputs, setInputs] = useState<number[]>([]);
  const [loader, setLoader] = useState(false)
  const [produits, setProduits] = useState([])
  const [produit, setProduit] = useState<number[]>([])
  const [loading, setLoading] = useState(false)
  const userId = localStorage.getItem("user")
  const token = localStorage.getItem("token")
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    setInputs(Array.from({ length: duration.nombreProduit }, (_, index) => index));
  }, [duration]);

  const updateProduct = async () => {
    setLoader(true)
    try {
      const { data } = await axios.get(getAllProducts)
      console.log(data)
      // console.log(data.products.filter((item:any)=>item.a_recenser))
      setProduits(data.products)
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }
  }
  useEffect(() => {
    updateProduct()
  }, [])

  const choisirProduit = (id: number) => {
    const existProduit = produit.find(item => item === id)
    if (existProduit) {
      toast.error("produit déjà sélectionné")
      return
    }
    setProduit([...produit, id])
  }

  const saveData = async () => {
    const data = {
      user_id: userId,
      package_duration_id: duration.package_duration_id,
      product_ids: produit,
    }
    if (produit.length < duration.nombreProduit) {
      toast.error("Vous avez sélectionné le même produit à plusieurs reprise")
      return
    }
    setLoading(true)
    try {
      const response = await axios.post(saveSouscription, data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      toast.success("Produit enregistrée")
      console.log(response)
      navigate("/paiement_sous", { state: response.data })
      // setSouscription(response.data.data)
    } catch (error: any) {

      if (error.response) {
        toast.error(error.response.data.message.message)

        console.log(error)
        return
      }

    } finally {
      setLoading(false)
    }
  }
  return (
    <div className='w-full  bg-gray-100 p-8  '>
      <div className=" text-3xl flex flex-col justify-center items-center font-semibold mb-6">
        <div> {t("choix_produit")} </div>
        {
          loader ? <Loader /> :
            <div className=' w-5/6'>
              {inputs.map((index: number) => {
                return (
                  <select key={index} onChange={(e) => choisirProduit(Number(e.target.value))} className=' p-6 mt-10 w-full text-[25px]'>
                    <option value="" className='text-[20px]'>{t("choisir_produit")} </option>
                    {
                      produits.map((product: any, index) => (
                        <option key={index} value={product.product_id}>{product.product_name}</option>
                      ))
                    }
                  </select>
                )
              })}
            </div>
        }
        <div className="flex justify-center w-4/5  py-5">
          <CustomButton
            rounded
            disabled={loading}
            className="bg-primary w-full text-white px-4 py-2"
            onClick={saveData}
          >
            <span className="text-[20px]">{loading ? "saving..." : "Valider les produits"}</span>
          </CustomButton>
        </div>
      </div>
      <ToastContainer position='top-center' />
    </div>
  )
}

export default SelectProducts
